import { useCacheInfiniteIndexQuery } from '../../../common/reactQuery/hooks/useCacheInfiniteIndexQuery';
import {
  FetchProductMaterialsQueryResponse,
  FETCH_PRODUCT_MATERIALS_QUERY
} from '../../queries/fetchProductMaterials.query';
import { FETCH_CACHE_PRODUCT_MATERIALS_QUERY } from '../../queries/fetchCacheProductMaterials.query';

import {
  FetchFinProductCategoriesFilters,
  FetchProductCategoriesCacheKey,
  FetchProductCategoriesLimit,
  FetchProductCategoriesSort
} from '../../productsTypes';

import {
  INITIAL_PRODUCT_MATERIALS_FILTERS,
  INITIAL_PRODUCT_MATERIALS_LIMIT,
  INITIAL_PRODUCT_MATERIALS_SORT
} from '../../productsConstants';
import { CategoriesPermissions } from '../../../categories/categoriesConstants';

const scope = 'categories';

const options = {
  staleTime: 1000 * 60 * 60
};

interface ProductMaterialsDefaultOptions {
  cacheKey: FetchProductCategoriesCacheKey;
  initialFilters?: FetchFinProductCategoriesFilters;
  initialSort?: FetchProductCategoriesSort;
  initialLimit?: FetchProductCategoriesLimit;
  options?: {
    staleTime?: number;
    enabled?: boolean;
    enabledPlaceholder?: boolean;
  };
}

function useFinProductMaterials({
  cacheKey,
  initialFilters = INITIAL_PRODUCT_MATERIALS_FILTERS,
  initialSort = INITIAL_PRODUCT_MATERIALS_SORT,
  initialLimit = INITIAL_PRODUCT_MATERIALS_LIMIT
}: ProductMaterialsDefaultOptions) {
  const {
    items,
    itemsError,
    isFetched,
    isPlaceholderData,
    isFetchingNextPage,
    currentFilters,
    hasNextPage,
    loadMoreItems,
    filterItems,
    changeItemsFilters
  } = useCacheInfiniteIndexQuery<FetchProductMaterialsQueryResponse>({
    action: CategoriesPermissions.READ_PRODUCT_CATEGORIES_INDEX_ES_QUERY,
    cacheKey,
    cacheQuery: FETCH_CACHE_PRODUCT_MATERIALS_QUERY,
    defaultApi: 'cache_api',
    query: FETCH_PRODUCT_MATERIALS_QUERY,
    initialFilters,
    initialSort,
    initialLimit,
    scope,
    options
  });

  return {
    productMaterials: items,
    productMaterialsErrorMessage: itemsError,
    productMaterialsFetched: isFetched,
    productMaterialsIsPlaceholderData: isPlaceholderData,
    productMaterialsFetchingNextPage: isFetchingNextPage,
    productMaterialsFilters: currentFilters,
    hasNextProductMaterialsPage: hasNextPage,
    loadMoreProductMaterials: loadMoreItems,
    productMaterialsFilterSearchValue: currentFilters?.name?.ilike,
    filterProductMaterials: filterItems,
    changeProductMaterialsFilters: changeItemsFilters
  };
}

export default useFinProductMaterials;
